import R from 'ramda';
import { combineReducers } from 'redux';
import * as utilities from '../reducers/utils';
import * as actions from '../actions';

function byId(state = {}, action) {
  switch (action.type) {
    case actions.REQUEST_ORDERED_COMPANIES_OVERVIEW_SUCCESS:
      return R.reduce(utilities.byId, {}, action.data.items);
    default:
      return Object.assign({}, state);
  }
}

function ids(state = [], action) {
  switch (action.type) {
    case actions.REQUEST_ORDERED_COMPANIES_OVERVIEW_SUCCESS:
      return R.pluck('id', action.data.items);
    default:
      return Object.assign([], state);
  }
}

function loading(state = false, action) {
  switch (action.type) {
    case actions.REQUEST_ORDERED_COMPANIES_OVERVIEW_START:
      return true;
    case actions.REQUEST_ORDERED_COMPANIES_OVERVIEW_SUCCESS:
    case actions.REQUEST_ORDERED_COMPANIES_OVERVIEW_ERROR:
      return false;
    default:
      return state;
  }
}

function error(state = null, action) {
  switch (action.type) {
    case actions.REQUEST_ORDERED_COMPANIES_OVERVIEW_START:
    case actions.REQUEST_ORDERED_COMPANIES_OVERVIEW_SUCCESS:
      return null;
    case actions.REQUEST_ORDERED_COMPANIES_OVERVIEW_ERROR:
      return action.err.message || process.env.ERR_GENERIC;
    default:
      return state;
  }
}

function total(state = 0, action) {
  switch (action.type) {
    case actions.REQUEST_ORDERED_COMPANIES_OVERVIEW_SUCCESS:
      return action.data.totalItems;
    default:
      return state;
  }
}

const summaries = combineReducers({
  byId,
  ids,
  loading,
  error,
  total,
});

export default summaries;
